import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { mergeSiteContent } from "../utils/helpers";

export const PUBLIC_PAGE_OPTIONS = [
  { key: "home", label: "Accueil", routes: ["/"] },
  { key: "latdior", label: "Latdior", routes: ["/latdior", "/merch"] },
  { key: "artistes", label: "Artistes", routes: ["/artistes"] },
  { key: "news", label: "News", routes: ["/news"] },
  { key: "studio", label: "Studio", routes: ["/studio"] },
  { key: "booking", label: "Réservation studio", routes: ["/reservation-studio"] },
  { key: "services", label: "Services", routes: ["/services", "/services/:serviceId"] },
  { key: "videos", label: "Vidéos", routes: ["/videos"] },
  { key: "contact", label: "Contact", routes: ["/contact"] },
  { key: "login", label: "Connexion", routes: ["/connexion"] },
  { key: "account", label: "Compte utilisateur", routes: ["/compte"] },
  { key: "cart", label: "Panier", routes: ["/panier"] },
  {
    key: "legal",
    label: "Pages légales",
    routes: ["/mentions-legales", "/confidentialite", "/cgu"],
  },
];

export default function PageAccessGuard({ pageKey, children }) {
  const [site, setSite] = useState(() => mergeSiteContent());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const off = onSnapshot(
      doc(db, "admin", "content"),
      (snap) => {
        setSite(mergeSiteContent(snap.exists() ? snap.data() : {}));
        setLoading(false);
      },
      () => {
        setSite(mergeSiteContent());
        setLoading(false);
      }
    );
    return () => off();
  }, []);

  if (loading) {
    return <main className="min-h-[78vh] bg-black" />;
  }

  const access = site.pageAccess?.[pageKey] || {};
  if (access.status === "active" || !access.status) return children;

  const deleted = access.status === "deleted";
  return (
    <main className="grid min-h-[78vh] place-items-center bg-black px-6 py-24 text-white">
      <section className="max-w-2xl rounded-lg border border-white/10 bg-zinc-950 p-8 text-center shadow-2xl md:p-12">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-red-500">
          Unlimited Session
        </p>
        <h1 className="mt-4 break-words text-3xl font-black uppercase sm:text-4xl md:text-6xl">
          {deleted ? "Page indisponible" : "Page momentanément fermée"}
        </h1>
        <p className="readable-copy mt-5 text-lg text-gray-300">
          {access.message || "Cette page est momentanément indisponible."}
        </p>
        {pageKey !== "home" && (
          <Link
            to="/"
            className="mt-7 inline-flex rounded-full bg-white px-6 py-3 text-sm font-bold uppercase text-black transition hover:bg-red-600 hover:text-white"
          >
            Retour à l'accueil
          </Link>
        )}
      </section>
    </main>
  );
}
